import { useClients } from '@/features/client-relationships';
import type { ClientListParams } from '@/features/client-relationships';

export type UseClientListParams = ClientListParams & {
  sortBy?: 'firstName' | 'createdAt'; // Deprecated: sort is always createdAt DESC
  sortOrder?: 'asc' | 'desc'; // Deprecated: sort is always createdAt DESC
  enabled?: boolean;
};

/**
 * SP client list hook — delegates to the unified useClients hook.
 * @deprecated Use useClients from @/features/client-relationships directly.
 *
 * @param _providerId - Ignored; the backend determines the professional from JWT
 * @param params - Pagination, search, and (deprecated) sort params
 */
export function useClientList(_providerId: string, params: UseClientListParams) {
  const { enabled = true, sortBy: _, sortOrder: __, ...queryParams } = params;
  return useClients(queryParams, enabled);
}
